import React from 'react';

import classes from './Overlay.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormattedMessage } from 'react-intl';

export const OVERLAY_SIZE_SMALL = "small";
export const OVERLAY_SIZE_MEDIUM = "medium";
export const OVERLAY_SIZE_LARGE = "large";



const overlay = (props) => {
    
        const capitalize = (string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    
        const config = {
            [OVERLAY_SIZE_SMALL]: {
                iconSize: "2x"
            },
            [OVERLAY_SIZE_MEDIUM]: {
                iconSize: "4x"
            },
            [OVERLAY_SIZE_LARGE]: {
                iconSize: "6x"
            }
        }
    
        let size = props.size || OVERLAY_SIZE_MEDIUM;
        let overlay = config[size];
        let title = props.title ? <FormattedMessage id={"overlay.title." + props.title} defaultMessage={capitalize(props.title)} /> : <FormattedMessage id={"overlay.title." + props.title} defaultMessage=" " />
        let info = <FormattedMessage id={"overlay.info." + props.info} defaultMessage=" " />

        return (
            <div className={[classes.Overlay, classes[props.color]].join(' ')}>
                <p className={[classes.Title, classes[size]].join(' ')}>{title}</p>
                <FontAwesomeIcon icon="cog" className={['fa-spin', classes[props.color]].join(' ')} size={overlay.iconSize}/>
                <p className={[classes.Info, classes[size]].join(' ')}>{info}</p>
            </div>
        );
    }    

export default overlay;
